import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';
import {message, Pagination, Popconfirm, Table} from 'antd';
import { withWindowSize } from 'air-with-window-size';
import AirButton from "../../../../common/components/AirButton";
import moment from 'moment';
import PropTypes from "prop-types";
import './GeofencesTable.css';
import {DeleteIcon} from "../../../../common/icons";

const pageSizeDefault = 7;
const mapByField = fieldname => el => el[fieldname];

@inject('commonStore', 'translationsStore', 'geofencesStore')
@observer
class GeofencesTable extends Component {
  constructor(props) {
    super(props);
    this.defaultPageSize = 1;
    const dataSource = this.buildDataSourceWithKeys(this.props.geofences);
    const pageSize = this.defaultPageSize;

    let pagination = false;
    let paginationText = '';
    this.state = {
      dataSourceBuffer: dataSource,
      selectedRowKeys: [],
      pageSize,
      pagination,
      paginationText
    };
  }

  static contextTypes = {
    router: PropTypes.object
  };

  componentDidMount = () => {
    const dataSource = this.buildDataSourceWithKeys(this.props.geofences);
    if (!isEqual(dataSource, this.state.dataSourceBuffer) || (dataSource.length > 0 && !this.state.pagination)) {
      this.buildPagination();
    }
  };

  componentDidUpdate(prevProps) {
    const someSizeChanged = prevProps.componentHeight !== this.props.componentHeight || prevProps.windowHeight !== this.props.windowHeight;
    const dataSource = this.buildDataSourceWithKeys(this.props.geofences);
    if (someSizeChanged || !isEqual(dataSource, this.state.dataSourceBuffer) || (dataSource.length > 0 && !this.state.pagination)) {
      this.buildPagination();
    }
  }

  helperPageSize = () => {
    const defaultDocHeight = 800;
    if (this.props.documentHeight === defaultDocHeight) {
      return pageSizeDefault;
    } else {
      return Math.floor((this.props.documentHeight * pageSizeDefault) / defaultDocHeight);
    }
  };

  changePageSize = pageSize => {
    this.setState({ pageSize });
  };

  helperPaginationText = (start, end, length) => {
    const { translationsStore } = this.props;
    if (length === 0) return `0 ${translationsStore.translate('geofences')}`;
    else if (length === 1) return `1 ${translationsStore.translate('geofences')}`;
    else return `${start}-${end} ${translationsStore.translate('of')} ${length} ${translationsStore.translate('geofences')}`;
  };

  buildDataSourceWithKeys = collection => collection.map((item, index) => ({ ...item, key: index }));

  buildPagination = () => {
    const dataSource = this.buildDataSourceWithKeys(this.props.geofences);
    const pageSize = this.helperPageSize();
    const pagination = {
      total: dataSource.length,
      defaultCurrent: 1,
      current: 1,
      // hideOnSinglePage: true,
      pageSize,
      simple: true,
      size: 'small',
      onChange: this.onPageChange
    };
    const start = 1;
    const end = Math.min(pagination.pageSize, pagination.total);

    const paginationText = this.helperPaginationText(start, end, dataSource.length);
    this.setState({
      dataSourceBuffer: dataSource,
      pageSize,
      pagination: { ...pagination },
      paginationText
    });
  };

  onPageChange = (page, pageSize) => {
    const dataSource = this.buildDataSourceWithKeys(this.props.geofences);
    const { pagination } = this.state;
    const start = (page - 1) * pageSize + 1;
    const end = Math.min(page * pageSize, pagination.total);
    let paginationText = this.helperPaginationText(start, end, dataSource.length);
    this.setState({
      dataSourceBuffer: dataSource,
      pagination: { ...pagination, current: page },
      paginationText
    });
  };

  deleteGeofence = geofence => {
    this.props.geofencesStore.deleteGeofence(geofence).then(() => {
        message.success(this.props.translationsStore.translate('geofence.geofenceTable.deleted'));
    }).catch(() => {
      message.error(this.props.translationsStore.translate('geofence.geofenceTable.deleteError'));
    });
  };

  render() {
    const { geofences, commonStore, translationsStore } = this.props;

    const dataSource = this.buildDataSourceWithKeys(geofences);

    const columns = [
      {
        key: 'name',
        dataIndex: 'name',
        title: translationsStore.translate('geofence.geofenceTable.headerLabels.name'),
        render: (text, record) => record.name
      },
      {
        key: 'assignedVehicles',
        dataIndex: 'assignedVehicles',
        align: 'center',
        title: translationsStore.translate('geofence.geofenceTable.headerLabels.assignedVehicles'),
        render: (text, record) => record.vehicles.length
      },
      {
        key: 'assignedSchedules',
        dataIndex: 'assignedSchedules',
        align: 'center',
        title: translationsStore.translate('geofence.geofenceTable.headerLabels.assignedSchedules'),
        render: (text, record) => record.schedules.length
      },
      {
        key: 'trigger',
        dataIndex: 'trigger',
        title: translationsStore.translate('geofence.geofenceTable.headerLabels.trigger'),
        render: (text, record) => (record.schedules.length > 0 ? record.schedules.map(mapByField('type')).includes("BOTH") ? translationsStore.translate('geofence.type.INSIDE') + '/' + translationsStore.translate('geofence.type.OUTSIDE') : uniq(record.schedules.map(mapByField('type'))).sort().map(x => translationsStore.translate('geofence.type.' + x)).join('/') : translationsStore.translate('geofence.geofenceTable.notAvailable'))
      },
      {
        key: 'status',
        dataIndex: 'status',
        title: translationsStore.translate('geofence.geofenceTable.headerLabels.status'),
        render: (text, record) => translationsStore.translate('geofence.status.' + record.status)
      },
      {
        key: 'createdAt',
        dataIndex: 'createdAt',
        align: 'center',
        className: 'ColumnCentered',
        title: translationsStore.translate('geofence.geofenceTable.headerLabels.createdAt'),
        render: (text, record) => <span>{record.createdAt ? moment(record.createdAt).format(commonStore.longDateFormat.L) : '-'}</span>,
      },
      {
        render: (text, record) => <AirButton className="backButton" size="large" light="true" style={{marginLeft: '0px'}} label={translationsStore.translate("geofence.geofenceTable.details")} onClick={() => {
          this.context.router.history.push(`/geofence/${record.id}`);
        }}/>
      },
      {
        width: '45px',
        render: (text, record) =>
          <Popconfirm
            title={translationsStore.translate('geofence.geofenceTable.deleteConfirm')}
            onConfirm={() => this.deleteGeofence(record)}
            okText={translationsStore.translate('geofence.geofenceTable.deleteConfirmYes')}
            cancelText={translationsStore.translate('geofence.geofenceTable.deleteConfirmNo')}
            placement={'left'}
          >
            <div className={'DeleteIconContainer'}>
              <DeleteIcon className={'BiggerDeleteIcon'}/>
            </div>
          </Popconfirm>
      }
    ];

    return (
      <div className="GeofencesTable">
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={this.state.pagination}
          rowClassName="GeofenceRow"
        />
        {!commonStore.loading && (
          <div className="GeofencesTablePagination">
            <div>{this.state.paginationText}</div>
            {dataSource.length > this.helperPageSize() && <Pagination {...this.state.pagination} />}
          </div>
        )}
      </div>
    );
  }
}

export default withWindowSize(GeofencesTable);



// WEBPACK FOOTER //
// ./src/components/App/Geofence/GeofencesTable/GeofencesTable.js